/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */
import type { HotspotButtonColor } from './hotspotButtonColor'
import type { HotspotButtonIcon } from './hotspotButtonIcon'
import type { HotspotButtonShape } from './hotspotButtonShape'
import type { HotspotButtonVariant } from './hotspotButtonVariant'
import type { HotspotEnterAnimation } from './hotspotEnterAnimation'
import type { HotspotExitAnimation } from './hotspotExitAnimation'

/**
 * プレイヤーが描くボタンの見た目（ADR-0024）。null なら透明なクリック領域
 */
export interface HotspotAppearance {
  exit: HotspotExitAnimation
  enter: HotspotEnterAnimation
  icon: HotspotButtonIcon
  shape: HotspotButtonShape
  /**
   * color=CUSTOM のときの色（#RRGGBB）。それ以外は null @example "#FF6600"
   * @nullable
   */
  customColor: string | null
  color: HotspotButtonColor
  variant: HotspotButtonVariant
}
